(function () {
  'use strict';

  if (customElements.get('header-sidebar-stories')) return;

  class HeaderSidebarStories extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.compose());
    }

    compose() {
      if (!this.isConnected) return;
      if (this.dataset.headerStoriesComposed === 'true') return;

      const viewer = this.querySelector('[data-stories-viewer]');
      const stage = viewer && viewer.querySelector('[data-stories-stage]');
      const progress = viewer && viewer.querySelector('[data-header-stories-progress]');
      const items = Array.from(this.querySelectorAll('[data-header-story-item]'));
      if (!viewer || !stage || !progress || !items.length) return;

      const playPreviews = this.dataset.playVideoPreviews === 'true';
      const showCta = this.dataset.showCta === 'true';
      const panelRadius = Number.parseFloat(this.dataset.panelRadius || '48');

      items.forEach((item, index) => {
        const trigger = item.querySelector('[data-stories-trigger]');
        const panelSource = item.querySelector('[data-header-story-panel-source]');
        const panel = panelSource && panelSource.querySelector('[data-stories-panel]');
        const video = item.querySelector('.header-sidebar-story-item__video');

        if (trigger) trigger.dataset.storiesIndex = String(index);
        if (video && playPreviews) video.classList.add('stories-card__video');

        if (panel) {
          panel.dataset.storiesIndex = String(index);
          panel.classList.toggle('is-active', index === 0);
          panel.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
          if (index === 0) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }

          const cta = panel.querySelector('.stories-viewer__cta');
          if (cta && !showCta) cta.hidden = true;
          if (cta && showCta) cta.style.setProperty('--stories-cta-radius', `${panelRadius}px`);
          stage.appendChild(panel);
        }

        if (panelSource) panelSource.remove();

        const progressItem = document.createElement('span');
        progressItem.className = `stories-viewer__progress-item${index === 0 ? ' is-active' : ''}`;
        progressItem.dataset.storiesProgress = '';
        progress.appendChild(progressItem);
      });

      this.dataset.headerStoriesComposed = 'true';
      if (typeof window.AxiomStoriesInit === 'function') window.AxiomStoriesInit(this);
    }

    disconnectedCallback() {
      if (this._storiesController && typeof this._storiesController.destroy === 'function') {
        this._storiesController.destroy();
      }
    }
  }

  customElements.define('header-sidebar-stories', HeaderSidebarStories);
})();
